import React from 'react';
import { MdExplore } from 'react-icons/md';
import '../styles/compsStyles/catline.css'

export const CATLINE_LIST = [
  'Funny', 'Business', 'Fashion', 'Music', 'Sports', 'Gaming', 'News', 'Tech',
  'Food', 'Travel', 'Education', 'Art', 'Health', 'Movies', 'Science', 'DIY',
  'Animals', 'Cars', 'Beauty', 'French', 'About'
];

export const parseCatline = (value) => {
  const raw = Array.isArray(value) ? value : String(value || '').split(',')
  const allowed = new Set(CATLINE_LIST)
  const seen = new Set()
  const next = []
  raw.forEach((item) => {
    const name = CATLINE_LIST.find(entry => entry.toLowerCase() === String(item || '').trim().toLowerCase())
    if (!name || !allowed.has(name) || seen.has(name)) return
    seen.add(name)
    next.push(name)
  })
  return next
}

export const catlineKey = (value) => parseCatline(value).join(',')

const Catline = props =>{
  const selected = parseCatline(props.iscategory)
  const isAll = selected.length === 0

  const pick = (name) => {
    if (typeof props.setCategory !== 'function') return
    if (!name) {
      props.setCategory([])
      return
    }
    const on = selected.includes(name)
    props.setCategory(on ? selected.filter(item => item !== name) : selected.concat(name))
  }

  return(
    <div className='catline'>
      <button
        type="button"
        className="catline__explore"
        aria-label="Explore"
        onClick={() => pick('')}
      >
        <MdExplore />
      </button>

      <button
        type="button"
        className={isAll ? 'selected' : 'cats'}
        onClick={() => pick('')}
      >
        All
      </button>

      {CATLINE_LIST.map((item) => (
        <button
          type="button"
          key={item}
          className={selected.includes(item) ? 'selected' : 'cats'}
          aria-pressed={selected.includes(item)}
          onClick={() => pick(item)}
        >
          {item}
        </button>
      ))}
    </div>
  )
}

export default Catline;
